export class PolicyResponse {
    PolicyNumber: string;
    PolicyStatus: string;

    constructor(policyNumber: string, policyStatus: string) {
      this.PolicyNumber = policyNumber;
      this.PolicyStatus = policyStatus;
    }
  }
